import type { WidgetVariant } from "@/types";
import { WidgetVariantContext } from "./widget-variant";

export function WidgetVariantProvider({
  variant,
  children,
}: {
  variant: WidgetVariant;
  children: React.ReactNode;
}) {
  return (
    <WidgetVariantContext.Provider value={variant}>
      {children}
    </WidgetVariantContext.Provider>
  );
}
